export default "__VITE_ASSET__0652aa92__"